<template>
    <div>
        <nav-bar :info="info" :notifications="notifications"/>
        <router-view :info="info" :notifications="notifications"/>
        <error-messages show5XXError/>
        <page-footer/>
        <idle-modal v-if="isIdle"/>
    </div>
</template>

<script>
    import NavBar from '~/components/Shared/Partials/NavBar';
    import PageFooter from '~/components/Shared/Partials/Footer';
    import IdleModal from "../components/Shared/UIComponents/IdleModal";

    export default {
        components: {
            IdleModal,
            NavBar,
            PageFooter
        },
        data() {
            return {
                isIdle: false,
            };
        },
        props: ['info', 'notifications'],
        onIdle() {
            // temporarily disabling the idle popup due to bug #79392
            // this.isIdle = true;
        },
        created() {
            this.$eventBus.$on('exiting-window', (exitingWindow) => {
                this.isIdle = !exitingWindow;
            })
        }
    }
</script>
